const normalizeRangeValue = (value, range) => {
  if (!range) {
    return null;
  }
  if (typeof range.min !== "undefined" && value < range.min) {
    return range.min;
  }
  if (typeof range.max !== "undefined" && value > range.max) {
    return range.max;
  }
  return value;
};
export {
  normalizeRangeValue
};
